import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "../locales/en/common.json";
import enPreChat from "../locales/en/pre-chat.json";
import enPreSms from "../locales/en/pre-sms.json";
import enPostChat from "../locales/en/post-chat.json";

import esCommon from "../locales/es/common.json";
import esPreChat from "../locales/es/pre-chat.json";
import esPreSms from "../locales/es/pre-sms.json";
import esPostChat from "../locales/es/post-chat.json";

const resources = {
  en: {
    common: enCommon,
    preChat: enPreChat,
    preSms: enPreSms,
    postChat: enPostChat,
  },
  es: {
    common: esCommon,
    preChat: esPreChat,
    preSms: esPreSms,
    postChat: esPostChat,
  },
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    fallbackNS: "common",
    ns: ["common", "preChat", "preSms", "postChat"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "navigator", "htmlTag", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
      excludeCacheFor: ["cimode"],
      checkWhitelist: true,
      lookupQuerystring: "lang",
    },
    whitelist: ["en", "es"],
  });

export default i18n;
